"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var utilities_1 = require("../Themes/utilities");
exports.Row = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ", ";\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(-theme.grid.gutterWidth / 2);
});
var Column = styled_components_1.default('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 ", ";\n  width: ", "%;\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n"], ["\n  padding: 0 ", ";\n  width: ", "%;\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n  ", " {\n    width: ", "%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth / 2);
}, function (props) { return props.xs; }, utilities_1.mb('s'), function (props) { return props.s; }, utilities_1.mb('m'), function (props) { return props.m; }, utilities_1.mb('l'), function (props) { return props.l; }, utilities_1.mb('xl'), function (props) { return props.xl; });
var NUMBER_OF_COLUMNS = 12;
var C = React.memo(function (props) {
    var children = props.children, _a = props.xs, xs = _a === void 0 ? NUMBER_OF_COLUMNS : _a, restProps = __rest(props, ["children", "xs"]);
    function getAvailableSize(sizeName) {
        var sizesInOrder = ['xs', 's', 'm', 'l', 'xl'];
        var currentIndex = sizesInOrder.findIndex(function (item) {
            return item === sizeName;
        });
        var availableSize = null;
        for (var i = currentIndex; i >= 0; i--) {
            if (props[sizesInOrder[i]]) {
                availableSize = props[sizesInOrder[i]];
                break;
            }
        }
        return (100 / NUMBER_OF_COLUMNS) * availableSize;
    }
    return (React.createElement(Column, __assign({}, restProps, { xs: (100 / NUMBER_OF_COLUMNS) * xs, s: getAvailableSize('s'), m: getAvailableSize('m'), l: getAvailableSize('l'), xl: getAvailableSize('xl') }), children));
});
C.defaultProps = {
    xs: NUMBER_OF_COLUMNS,
};
exports.default = C;
var templateObject_1, templateObject_2;
